import {LauncherItem} from "@variocube/app-api";

export const AWESOME_BAR_HEIGHT = "3rem";
export const AWESOME_BAR_ZINDEX = 9999;
export const AWESOME_BAR_BACKGROUND = "rgba(0, 0, 0, 0.5)"

export interface AppLauncherItem extends LauncherItem {
    appId: string;
}